exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-survey-options-client-access-style__toggle {\n  margin-top: 4px;\n}\n\n.src-client-survey-options-client-access-style__toggleGrid {\n  display: flex;\n  flex-direction: row;\n}\n\n.src-client-survey-options-client-access-style__hr {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.src-client-survey-options-client-access-style__fancyRadioOptions {\n  margin-top: 16px;\n}\n\n.src-client-survey-options-client-access-style__explanationText {\n  font-size: 13px;\n}\n", ""]);

// exports
exports.locals = {
	"toggle": "src-client-survey-options-client-access-style__toggle",
	"toggleGrid": "src-client-survey-options-client-access-style__toggleGrid",
	"hr": "src-client-survey-options-client-access-style__hr",
	"fancyRadioOptions": "src-client-survey-options-client-access-style__fancyRadioOptions",
	"explanationText": "src-client-survey-options-client-access-style__explanationText"
};